module.exports = __webpack_public_path__ + "static/media/se_page7.ff767574.ogg";